import { render, staticRenderFns } from "./Actionbar.vue?vue&type=template&id=924aa482&scoped=true&"
import script from "./Actionbar.vue?vue&type=script&lang=js&"
export * from "./Actionbar.vue?vue&type=script&lang=js&"
import style0 from "./Actionbar.vue?vue&type=style&index=0&id=924aa482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924aa482",
  null
  
)

export default component.exports